import { useQuery } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useMarketplaces() {
  const { data, ...rest } = useQuery(['marketplaces'], () =>
    apiCalls.getMarketplaces().then(({ data: { marketplaces } }) => marketplaces)
  );
  return { marketplaces: data, ...rest };
}

export function useCtas() {
  const { data, ...rest } = useQuery(['ctas'], () => apiCalls.getCtas().then(({ data: { ctas } }) => ctas));
  return { ctas: data, ...rest };
}

export function useCtaGroups(params) {
  const { data, ...rest } = useQuery(['ctaGroups'], () =>
    apiCalls.getCtaGroupsV2(params).then(({ data: { ctaGroups } }) => ctaGroups)
  );
  return { ctaGroups: data, ...rest };
}

export function useItemCollections(params) {
  const { data, ...rest } = useQuery(['itemCollections'], () =>
    apiCalls.getItemCollections(params).then(({ data: { itemCollections } }) => itemCollections)
  );
  return { itemCollections: data, ...rest };
}
